import { render, staticRenderFns } from "./ProjectPOABitacora.vue?vue&type=template&id=70c476d0"
import script from "./ProjectPOABitacora.vue?vue&type=script&lang=js"
export * from "./ProjectPOABitacora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports